'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveFilters = function ActiveFilters(_ref) {
  var selected = _ref.selected,
      action = _ref.action,
      clear = _ref.clear,
      groupKey = _ref.groupKey,
      labelKey = _ref.labelKey;

  return _react2.default.createElement(_.SelectionList, {
    action: action,
    available: selected,
    clear: clear,
    clearPosition: 'last',
    clearText: (0, _i18n2.default)('clearFilters'),
    customClassName: 'ActiveFilters',
    groupKey: groupKey,
    hideClearWhenEmpty: true,
    labelKey: labelKey,
    layout: 'inline',
    selected: selected
  });
};

ActiveFilters.propTypes = {
  /**
   * Function with an item as its argument that is called on a click.
   */
  action: _propTypes2.default.func,
  /**
   * Function to clear the selection
   */
  clear: _propTypes2.default.func,
  /**
   * Key in each item of available to use as a label
   */
  labelKey: _propTypes2.default.string,
  /**
   * Key in each item of available to use as a group
   */
  groupKey: _propTypes2.default.string,
  /**
   * Active filter items.
   */
  selected: _propTypes2.default.array
};

ActiveFilters.defaultProps = {
  selected: [],
  labelKey: 'label',
  groupKey: 'tag'
};

exports.default = ActiveFilters;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/ActiveFilters.js
// module id = 256
// module chunks = 0